<!--
 * @Descripttion: 选项卡弹窗
 * @Author: zenghua.wang
 * @Date: 2021-12-24 09:51:07
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-12 14:53:19
-->
<template>
  <el-dialog
    :title="dialog.title"
    :visible.sync="dialog.show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    append-to-body
    width="50%"
    class="dialog"
  >
    <el-form
      ref="form"
      size="small"
      :model="column"
      :rules="rules"
      label-width="120px"
      label-suffix=":"
    >
      <el-form-item
        label="标签名"
        prop="label"
      >
        <el-input
          v-model="column.label"
          placeholder="请输入"
          style="width: 300px"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item
        label="标签值"
        prop="name"
      >
        <el-input
          v-model="column.name"
          placeholder="请输入"
          style="width: 300px"
          readonly
        ></el-input>
        <div class="xa-form-tips">备注：标签值默认生成，不可修改</div>
      </el-form-item>
    </el-form>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        size="small"
        @click="dialog.show = false"
      >取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="onSubmit"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'tabs-dialog',
  components: {},
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {}
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    column: {
      type: Object
    }
  },
  data() {
    return {
      rules: {
        label: [{ required: true, message: '请输入', trigger: 'blur' }],
        name: [{ required: true, message: '请选择', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('change', this.column)
          this.dialog.show = false
        } else {
          return
        }
      })
    }
  }
}
</script>
